import { LeanFormSchema, fieldRef } from '../types/config-form.types';
import { V3BatteryActiveSettings } from 'ngx-modbus';

export const BATTERY_ACTIVE_FORM: LeanFormSchema = {
  version: '2.0.0',
  id: 'battery-active-settings',
  name: 'Battery Active Settings',
  sections: [{
    id: 'battery-active',
    labelKey: 'batteryActiveSettings',
    registerTable: 'V3BatteryActiveSettings',
    controlRegister: 'BatteryActive_Oneshot',
    fields: [
      fieldRef(V3BatteryActiveSettings, 'BatteryActive_Control'),
      fieldRef(V3BatteryActiveSettings, 'BatteryActive_Control', {
        key: 'BatteryActive_Trigger',
        fieldType: 'trigger',
        labelKey: 'batteryActiveOneShot',
        triggerValue: 1,
        constraint: { label: 'batteryActiveOneShot' },
      }),
    ],
  }],
};
